<template>
  <div class="card">
    <van-row :class="`row ${half ? 'half' : 'full '}`" v-for="item in formList" :key="item.field">
      <van-col span="24">
        <div class="card-label">{{ item.label }}</div>
        <div class="card-value" v-if="item.fieldType === 'money'">￥{{ getMoneyText(data[item.field]) }}</div>
        <div class="card-value" v-else-if="item.fieldType === 'invoiceType'">{{ getInvoiceType(data[item.field]) }}</div>
        <div class="card-value" v-else-if="item.fieldType === 'status'">{{ getStatusText(data[item.field]) }}</div>
        <div class="card-value" v-else-if="item.fieldType === 'reimStatus'">{{ getReimStatus(data[item.field]) }}</div>
        <div class="card-value" v-else-if="item.fieldType === 'expenseType'">{{ getExpenseTypeText(data[item.field]) }}</div>
        <div class="card-value" v-else-if="item.fieldType === 'operate'" @click="handleShowPop">预览</div>
        <div class="card-value" v-else>{{ data[item.field] || '--' }}</div>
      </van-col>
    </van-row>
    <van-popup v-model="invoiceImgShow">内容</van-popup>
  </div>
</template>
<script>
import { Row, Col, Popup } from 'vant'
import { EXAMINE_STATUS_MAP, ENTRY_INVOICE_REIMBURSE_EXPENSETYPE, REIMSTATUSCONFIGMAP, INVOICE_TYPE_OPTIONS } from '@assets/config.js'
export default {
  components: {
    [Popup.name]: Popup,
    [Row.name]: Row,
    [Col.name]: Col
  },
  props: {
    formList: {
      type: Array,
      default: () => {}
    },
    half: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      invoiceImgShow: false
    }
  },
  methods: {
    handleShowPop () {
      this.invoiceImgShow = true
    },
    getInvoiceType (value) {
      if (INVOICE_TYPE_OPTIONS.find((i) => i.value === value)) {
        return INVOICE_TYPE_OPTIONS.find((i) => i.value === value).text
      }
      return '--'
    },
    getStatusText (value) {
      return EXAMINE_STATUS_MAP[value] || '--'
    },
    getReimStatus (value) {
      return REIMSTATUSCONFIGMAP[Number(value)] && REIMSTATUSCONFIGMAP[Number(value)].text
    },
    getMoneyText (value) {
      return value ? Number(value).toFixed(2) : '0.00'
    },
    getExpenseTypeText (value) {
      const text = []
      if (value) {
        value.split(',').forEach(i => {
          ENTRY_INVOICE_REIMBURSE_EXPENSETYPE[i] && text.push(ENTRY_INVOICE_REIMBURSE_EXPENSETYPE[i])
        })
      }
      return text.join(',')
    }
  }
}
</script>
<style lang="less" scoped src="./index.less" />
